import React from "react";
import { getAllowedPages, getRole } from "../../../utils/auth";

const allMenuItems = [
  {
    title: "Dashboard",
    iconStyle: <i className="flaticon-381-networking" />,
    to: "dashboard",
  },
  {
    title: "Appointments",
    iconStyle: <i className="flaticon-381-calendar-1" />,
    to: "appointments",
  },
  {
    title: "Banner",
    iconStyle: <i className="flaticon-381-photo" />,
    to: "banner",
  },
  {
    title: "AboutUs",
    iconStyle: <i className="flaticon-381-user-8" />,
    to: "about",
  },
  {
    title: "Why Choose Us",
    iconStyle: <i className="flaticon-381-star-1" />,
    to: "why-choose-us",
  },
   {
    title: "Services",
    iconStyle: <i className="flaticon-381-briefcase" />,
    to: "services",
  },
   {
    title: "FAQ",
    iconStyle: <i className="flaticon-381-help" />,
    to: "faq",
  },
  {
    title: "Gallery",
    iconStyle: <i className="flaticon-381-layer-1" />,
    to: "gallery",
  },
  {
    title: "Blogs",
    iconStyle: <i className="flaticon-381-notepad" />,
    to: "blogs",
  },
  {
  title: "Image Alt",
  iconStyle: <i className="flaticon-381-photo" />,
  to: "imagealt",
},
   
  {
    title: "Contact",
    iconStyle: <i className="flaticon-381-file" />,
    to: "contact",
  },
  {
    title: "Testimonials",
    iconStyle: <i className="flaticon-381-user-7" />,
    to: "testimonials",
  },
  {
    title: "Seo",
    iconStyle: <i className="flaticon-381-settings-2" />,
    to: "seo",
  },
  {
    title: "Roles",
    iconStyle: <i className="flaticon-381-user-9" />,
    to: "roles",
  },
];

export const getMenuList = () => {
  const role = getRole();
  const allowedPages = getAllowedPages();

  if (role === "admin") return allMenuItems;

  return allMenuItems.filter((item) => allowedPages.includes(item.to));
};